import { Icon } from '@runeffective/evo-design-system'
import Accordion from 'components/AdminFloorPlan/Accordion'
import { useState } from 'react'
import css from './index.module.scss'
import { metric, toMeters } from 'components/AdminFloorPlan/components/MeasurementInput/measurement'
import { Tooltip2 } from '@blueprintjs/popover2'
import { Position } from '@blueprintjs/core'
import { SafeDistancingLegend } from './SafeDistancingFilter'
import { GENERAL, MAPDETAILS, SAFEDISTANCING } from './viewFiltersCalculations'
import { IViewFiltersData } from '@api'

type ParentFilterProps = {
  isFiltered: boolean
  id: string
  viewFiltersData: IViewFiltersData
  disabled?: boolean
  children: React.ReactNode[]
}

const isGeneralOrMapDetails = (id: string) => id === GENERAL || id === MAPDETAILS

const ParentFilter = ({ children, ...restProps }: ParentFilterProps) => {
  const [open, setOpen] = useState(isGeneralOrMapDetails(restProps.id) ? true : false)
  const { getSingleFilterName, getFilterById } = restProps.viewFiltersData

  const { name, visible, tooltip, units, safeDistance, isSafeDistancing } = getFilterById(
    restProps.id
  )

  const getSafeDistance = () => {
    return `(${metric(units) && safeDistance ? toMeters(safeDistance).toFixed(1) : safeDistance}${
      metric(units) ? 'm' : 'ft'
    })`
  }

  const getHint = () => {
    if (restProps.id === SAFEDISTANCING) {
      return (
        <div onClick={(e) => e.stopPropagation()}>
          <Tooltip2
            compact
            content={
              isSafeDistancing ? (
                <SafeDistancingLegend safeDistance={safeDistance} units={units} />
              ) : (
                <span style={{ whiteSpace: 'nowrap' }}>
                  Go to Building and Floors management page to set the scale in order to enable safe
                  distancing (radius)
                </span>
              )
            }
            placement={Position.TOP}>
            <i className="fa-thin fa-circle-info" />
          </Tooltip2>
        </div>
      )
    }

    return null
  }

  const getName = () => {
    if (isGeneralOrMapDetails(restProps.id) || open) {
      return name
    }
    let displayName

    if (visible) {
      if (visible === children?.length) {
        displayName = `All ${name}`
      } else if (visible === 1) {
        displayName = `Only ${getSingleFilterName(restProps.id)}`
      } else {
        displayName = `${visible}/${children?.length} ${name}`
      }
    } else {
      displayName = `No ${name}`
    }

    if (restProps.id === SAFEDISTANCING) {
      return `${displayName} ${getSafeDistance()}`
    }
    return displayName
  }

  const getTooltip = () => {
    if (tooltip) return tooltip
    return `${visible ? 'hide' : 'show'} ${name?.toLowerCase()}`
  }
  const toolbar = (
    <div className={css.toolbar}>
      <Icon
        iconName={open ? 'chevron-down' : 'angle-right'}
        iconStyle="fal"
        size="sm"
        className={css.angleIcon}
      />
      <div className={css.parentFilterName}>
        <div className={css.hint}>{getHint()}</div>
        <div className={restProps.id === SAFEDISTANCING && !isSafeDistancing ? css.disabled : ''}>
          {getName()}
        </div>
      </div>
      {!isGeneralOrMapDetails(restProps.id) && (
        <Tooltip2 content={getTooltip()}>
          <Icon iconName={'fa-thin fa-eye'} iconStyle="fal" size="sm" />
        </Tooltip2>
      )}
    </div>
  )
  const content = <div>{children}</div>
  const data = { toolbar, content }
  return (
    <Accordion
      data={[data]}
      selIndx={isGeneralOrMapDetails(restProps.id) ? 0 : undefined}
      onChange={(_i, isOpen) => setOpen(isOpen)}
    />
  )
}
export default ParentFilter
